import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { saveService, updateService } from './actions';
import Editor from '../../components/common/Editor';
import TextField from '../../components/common/TextField';
import CheckboxField from '../../components/common/CheckboxField';
import SelectField from '../../components/common/SelectField';
import DropNCropField from '../../components/common/DropNCropField';
import { SERVICE_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class ServiceForm extends Component {
  onSubmit = formProps => {
    const { lang } = formProps;
    const { config } = this.props;

    const serviceRequestData = {
      title: formProps.title,
      subtitle: formProps.subtitle,
      content: formProps.content,
      description: formProps.description,
      header: formProps.header,
      headerImageLarge: formProps.headerImageLarge.result,
      showOnHomepage: formProps.showOnHomepage.toString(),
      slug: formProps.slug
    };

    if (config && config.id) {
      // add new mutation for existing service
      this.props.updateService(serviceRequestData, config.id, lang, () => {
        this.props.history.push('/sluzby');
      });
    } else {
      // create brand new service
      this.props.saveService(serviceRequestData, lang, () => {
        this.props.history.push('/sluzby');
      });
    }
  };

  render() {
    const { config } = this.props;
    const { handleSubmit } = this.props;

    return (
      <div className="new-service">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            key="lang"
            component={SelectField}
            label="Jazyk"
            name="lang"
            disabled={config ? config.disableSelect : false}
            validate={required}
          >
            <option value="" key="empty">
              Vyberte jazyk
            </option>
            <option value="cs" key="cs">
              CZ
            </option>
            <option value="en" key="en">
              EN
            </option>
          </Field>
          <Field
            component={TextField}
            type="text"
            label="Hlavní nadpis"
            name="header"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Podnadpis"
            name="subtitle"
            validate={required}
          />
          <Field
            component={DropNCropField}
            label="Hlavní obrázek"
            name="headerImageLarge"
            validate={required}
            minCropBoxWidth={588}
            aspectRatio={16 / 9}
          />
          <div className="editor">
            {/*<Editor placeholder={'Write something...'} />*/}
            <Field
              name="content"
              component={Editor}
              label="Obsah"
              validate={required}
            />
          </div>
          <Field
            component={TextField}
            type="text"
            label="Title"
            name="title"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Url"
            name="slug"
            placeholder="nova-sluzba"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Meta description"
            name="description"
            validate={required}
          />
          <Field
            component={CheckboxField}
            label="Zobrazit na homepage"
            name="showOnHomepage"
            checked
          />
          <div className="form-buttons">
            <Button color="primary">Uložit</Button>
            <Button tag={Link} to="/sluzby" color="danger">
              Zpět na služby
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveService,
  updateService
};

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  ),
  reduxForm({ form: SERVICE_FORM_NAME })
)(ServiceForm);



// WEBPACK FOOTER //
// ./src/modules/ServiceForm/index.js